import { IconButton, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { FullScreenHandle } from 'react-full-screen';
import useBundleTranslation from 'i18n';
import { useEmbeddingContextVisible } from 'hooks/useEmbeddingContext';

export default function FullScreenButton({ fullScreenHandle }: { fullScreenHandle: FullScreenHandle }) {
    const { t } = useBundleTranslation(['components/common/viewer_controls_panel']);

    const hasIcon = useEmbeddingContextVisible('control_buttons.full_screen');
    if (!hasIcon) {
        return null;
    }

    return (
        <span id={'top-full-screen-icon'} data-test={'top-full-screen-icon'}>
            <Tooltip title={t('full_screen_btn_tooltip')}>
                <IconButton
                    sx={{ p: '6px' }}
                    onClick={(e: any) => {
                        e.preventDefault();
                        fullScreenHandle.enter();
                    }}
                >
                    <IconMi icon="full-screen" fontSize="16" />
                </IconButton>
            </Tooltip>
        </span>
    );
}
